import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
  stroke: "#FA477C",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "21.5",
  cy: "19.5",
  r: "6",
  fill: "#FA477C",
  stroke: "#F0F6F6"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }